import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Patient } from '../app/patients/patient';
import { Observable, Subject, Subscription } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { ReconnectingSocket } from './reconnecting-socket';

@Injectable({
  providedIn: 'root'
})

export class PatientsService {

  currentPatient: Patient;
  lmp;
  public Consultation: UntypedFormControl;
  letters: any;
  lettersChange = new Subject<any>();
  awlChange =  new Subject<any>();
  exitFromGastroExam =  new Subject<any>()
  awlIncomming = new Subject<string>();
  AWLStatus = "Waiting"
  AWLSock: ReconnectingSocket;
  lastAwlDate
  constructor(private http: HttpClient) {
    this.Consultation = new UntypedFormControl();
  }

  savePatient(p: Patient, pid: number = null) {
    let req = this.http.put("api/patient", { 'pid': pid, 'data': p })
    return req
  }

  getPatients(id: string, fname: string, lname: string, phone: string, uid, cb, page?: number, pageSize?: number, cross?: boolean, errCb?): Subscription {
    // Returns the Subscription so callers can cancel an in-flight search
    // (unsubscribing aborts the underlying HTTP request).
    return this.http.post<Patient[]>("api/patient", { 'ID': id, 'First': fname, 'Last': lname, 'Phone': phone, uid: uid, page: page, pageSize: pageSize, cross: cross ? '1' : undefined }).subscribe((data) => {
      cb(data);
    }, (error) => {
      console.log(error);
      // Without this the caller never learns the request failed and its loading flag stays stuck on.
      if (errCb) { errCb(error); }
    });
  }

  // Sites quick-flow: AWL row + exam + MWL in one call (backend gated on IsSite).
  quickExam(pid: number, examType: string) {
    return this.http.post("/api/quickexam", { PID: pid, ExamType: examType });
  }

  getPatient(pid: number, cb) {
    this.http.post<Patient>("api/patient", { 'PatID': pid }).subscribe((data) => {
      if (data)
        this.setPat(data);
      cb(true);
    }, (error) => {
      console.log(error);
      cb(false);
    });

  }

  getAWL(status: string, exam, search = null) {
    if (!search)
      return this.http.get('/api/awl/' + status +'/' + exam);
    return this.http.get('/api/awl/' + status + '/'+ exam, { params: search, })
  }

  saveAWL(awlid: number, time: string, lmp: string, examname: string, comment: string, pid: number, prn: string, code: string, examCodes: any[] = null, uid = false,refDocName=null,BranchProviderID=null,BranchProviderName=null,refDocLastName=null,PRN2=null,refDocLastName2=null,BranchProviderName2=null,BranchProviderID2=null,refDocName2=null,Code2=null) {
    
    let d = new Date().toISOString().slice(0, 10) + ' ' + time;
    let lmpd = null;
    if (lmp) {
      lmpd = new Date(lmp);
      lmpd.setTime(lmpd.getTime() + 5 * 60 * 60 * 1000)
    }
    let details = { LMP: lmpd, ExamDate: d, ExamCode: examname, PID: pid, note: comment, PRN: (prn ? prn : null), Code: (code ? code : null), uid: (uid ? uid : null),refDocName,BranchProviderID,BranchProviderName,refDocLastName,PRN2,refDocLastName2,BranchProviderName2,BranchProviderID2,refDocName2,Code2};
    if (awlid){
      details['AutoIndex'] = awlid;
      this.awlChange.next(awlid)
    }
    if(examCodes)
      details['examCodes'] = examCodes;
    if(lmp){
      this.lmp=lmp;
    }
    
    return this.http.post('/api/awl', details);
  }

  deleteAWL(awlid: number) {
    return this.http.delete('/api/awl/' + awlid)
  }

  updateAWLStatue(awlid: number){
    return this.http.put("api/awl/changeStatus", {awlid})
   
  }


  saveAWLComment(comment: string, AWLID: number) {
    this.http.post('/api/awlcomment', { Reason: comment, AutoIndex: AWLID }).subscribe((ok) => { },
      (err) => {
        console.log(err);
      })
  }


  setPat(pat: Patient, defaults = false, awl=null) {
    let p = new Patient(pat.ID, pat.First, pat.Last, pat.Phone, pat.HMO);
    for (let key in pat) {
      if (pat[key])
        p[key] = pat[key];
    }
    if (defaults)
      p.PID = 0;
    this.currentPatient = p;
  }

  getPat(): Patient {
    return this.currentPatient;
  }

  ageAtEDD(edd: Date, months = false, toadd = 0) {
    if (months)
      return this.getAgeMo(edd, toadd);
    return this.currentPatient.getAge(edd);
  }

  getAgeMo(atDate: Date = new Date(), toadd = 0) {
    if (!this.currentPatient.Birth)
      return "";
    let months = toadd + this.monthDiff(new Date(Date.parse(this.currentPatient.Birth)), atDate);//months between birthday and edd (for example)
    let yrs = Math.floor(months / 12);
    let mo = months - yrs * 12;
    return yrs + "y" + mo + "m";
  }
  monthDiff(d1: Date, d2: Date) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    if (d1.getDate() > d2.getDate())
      months--;
    return months <= 0 ? 0 : months;
  }

  getConsultationLetter(patient) {
    this.http.get(`/api/letters/${patient.GID}/${patient.PID}`).subscribe(
      (res) => {
        this.letters = res;
        this.lettersChange.next(res);
      }
    )
  }

  setConsultationLetter(patient, text) {
    this.Consultation.patchValue({ consulationText: text })
    this.http.post('/api/letters', { patient: patient, FormContent: this.Consultation.value.consulationText, FormType: "Consultation" }).subscribe(
      (res) => {
        console.log(res);
      }
    )
  }

  checkPRN(tz:string,prn:string,treatmentcode: string){
    return this.http.get('/api/leumit/checkprn/'+ tz +'/'+ prn+'/' + treatmentcode);
  }

  getPayment(awlid){
    return this.http.get('/api/cardio/payment/'+awlid);
  }

  macabiLookup(patid: string, idcode: string, awlid: number, exp:string,inoffice:boolean){
    if(inoffice)
      return this.http.get('http://localhost:8088/checkmacabi/'+ patid + '/' + idcode + '/' + awlid+'/'+ (exp? exp:'0'));
    return this.http.get('/api/cardio/checkmacabi/'+ patid + '/' + idcode + '/' + awlid+'/'+ (exp? exp:'0'));
  }


  savePaymentAWL(awlid: number,payment){
    return this.http.post('/api/cardio/payment',{
      AWLID: awlid,
      HMOcovered: payment["approved"],
      PatPayment: payment['payment'],
      CollectAtClinic: !payment['macabipay'],
      HMOnote: payment["note"]
    });
  }

  receivePat(awlid:number){
    return this.http.get('/api/cardio/receive/'+ awlid);
  }

  ageRange(age){
    if(! age)
     return false
    var year = age.split("y")[0];
    var month = age.split("y")[1];
    // var year = this.getPat().getAge().split(" ")[0].split(".")[0]
    // var month = this.getPat().getAge().split(" ")[0].split(".")[1]
    if((Number(year) < 20) || Number(year) >= 46){
      return false
    }
    return true;
  }
  setExamCode(title,awlid){
    return this.http.post(`/api/cardio/changeAwlExam/${awlid}`, {title: title});
  }

  openWebSocket(gid = null){
    if(! this.AWLSock || this.AWLSock.readyState != WebSocket.OPEN){
      let path  =  (window.location.protocol == 'https:' ? 'wss://': 'ws://') + window.location.hostname + (window.location.port? ':' + window.location.port: '') + '/api/awlsocket' + (gid ? '/' + gid: '');
      this.AWLSock = new ReconnectingSocket(path, (e)=>{
        this.awlIncomming.next(null);
      });
    }
  }

  closeWebSocket(){
    if(this.AWLSock)
      this.AWLSock.close();
  }

  findPatBelinson(code:string){
    return this.http.get('/api/belinson/patient/' + code);
  }
  
  getPatAWL(){
    try {
      this.http.get('/api/newExams/getAWL/' +this.getPat().PID).subscribe((data:any) =>{
        this.currentPatient.AWLID = data
      })
    } catch (error) {
      console.log(error);
      
    }
  }

  sendMacabi(startdt,enddt){
    return this.http.get('/api/stats/sendmacabi?from='+startdt+'&until='+enddt);
  }

  reassign(pat){//patient and awl to another doctor
    return this.http.get('/api/awlreassign/'+ pat.AWLID + '/' + pat.PID + '/' + pat.UID);
  }

  copyPat(pid:number,uid: number){
    return this.http.get('/api/copypat/'+ pid + '/' + uid);
  }

  getPreg(pat:Patient){

  }
}
